import { CSSObject } from '@emotion/react'
import { Color } from '@opallabs/gem'
import { WithRequiredTheme } from '@opallabs/lapidary'

export const modal: CSSObject = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  inlineSize: '100%',
  blockSize: '100%',
  pointerEvents: 'none',

  img: {
    maxInlineSize: '90%',
    maxBlockSize: '90%',
    inlineSize: 'auto',
    blockSize: 'auto',
  },
}

export const closeButton = ({ theme }: WithRequiredTheme): CSSObject => ({
  inlineSize: '32px',
  blockSize: '32px',
  position: 'fixed',
  insetBlockStart: '24px',
  insetInlineEnd: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'none',
  border: 0,
  padding: 0,
  cursor: 'pointer',
  borderRadius: '6px',
  transition: 'background-color 0.15s ease-in-out, color 0.15s ease-in-out',
  pointerEvents: 'auto',

  color: Color[theme].Text.InvertedDefault,

  '&:hover': {
    backgroundColor: Color[theme].Surface.A100,
    color: Color[theme].Text.Default,
  },
})
